/**
 * Menu Book Landing Page
 * Main entry point for JavaScript functionality
 */ /**
 * PostHog Analytics Integration
 */ function $f91025ced40c6130$export$74b04d0e740afc5d() {
    // PostHog snippet
    !function(t, e) {
        var o, n, p, r;
        e.__SV || e.__SV && e.__SV.__loaded || (window.posthog = e, e._i = [], e.init = function(i, s, a) {
            function g(t, e) {
                var o = e.split('.');
                2 == o.length && (t = t[o[0]], e = o[1]), t[e] = function() {
                    t.push([
                        e
                    ].concat(Array.prototype.slice.call(arguments, 0)));
                };
            }
            (p = t.createElement('script')).type = 'text/javascript', p.crossOrigin = 'anonymous', p.async = !0, p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js', (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r);
            var u = e;
            for(void 0 !== a ? u = e[a] = [] : a = 'posthog', u.people = u.people || [], u.toString = function(t) {
                var e = 'posthog';
                return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e;
            }, u.people.toString = function() {
                return u.toString(1) + '.people (stub)';
            }, o = 'init yi Fr Mr mi Rr Or capture Li calculateEventProperties Dr register register_once register_for_session unregister unregister_for_session zr getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Nr jr createPersonProfile Ur Tr Hr opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing Ar debug L Lr getPageViewId captureTraceFeedback captureTraceMetric $r'.split(' '), n = 0; n < o.length; n++)g(u, o[n]);
            e._i.push([
                i,
                s,
                a
            ]);
        }, e.__SV = 1);
    }(document, window.posthog || []);
    posthog.init('phc_3g3aWKXpNYzWZRhIhvxqctQIw6QvP2UWCRS5EmM8Zzn', {
        cookieless_mode: 'on_reject',
        api_host: 'https://eu.i.posthog.com',
        defaults: '2025-05-24',
        person_profiles: 'identified_only'
    });
}
function $f91025ced40c6130$export$2c1f5f2ef3c49d7f(email) {
    if (window.posthog) posthog.capture('waitlist_signup', {
        email: email,
        source: 'landing_page'
    });
}


/**
 * Cookie Consent Management
 * Handles GDPR-compliant cookie consent banner and preferences
 */ const $9cf61c3cbfe44025$var$CONSENT_KEY = 'menubook_cookie_consent';
function $9cf61c3cbfe44025$export$4aed0829426ce4f9() {
    try {
        return localStorage.getItem($9cf61c3cbfe44025$var$CONSENT_KEY);
    } catch (e) {
        return null;
    }
}
function $9cf61c3cbfe44025$export$614f1ac7580ead5f(status) {
    try {
        localStorage.setItem($9cf61c3cbfe44025$var$CONSENT_KEY, status);
    } catch (e) {
        console.warn('Unable to save consent preference');
    }
}
function $9cf61c3cbfe44025$export$f4d3dcfc47dd8e3a(onAccept, onDecline) {
    const existing = $9cf61c3cbfe44025$export$4aed0829426ce4f9();
    // Don't show if already decided
    if (existing) {
        if (existing === 'accepted' && onAccept) onAccept();
        return;
    }
    // Create banner HTML
    const banner = document.createElement('div');
    banner.id = 'cookie-consent-banner';
    banner.className = 'cookie-consent-banner';
    banner.innerHTML = `
    <div class="cookie-consent-content">
      <p class="cookie-consent-text">
        We use cookies to improve your experience and analyze site traffic.
        <a href="./cookies.html" target="_blank" class="cookie-consent-link">Learn more</a>
      </p>
      <div class="cookie-consent-buttons">
        <button id="cookie-decline" class="cookie-consent-btn cookie-consent-btn-secondary">
          Decline
        </button>
        <button id="cookie-accept" class="cookie-consent-btn cookie-consent-btn-primary">
          Accept
        </button>
      </div>
    </div>
  `;
    // Add to page
    document.body.appendChild(banner);
    // Handle accept
    document.getElementById('cookie-accept').addEventListener('click', ()=>{
        $9cf61c3cbfe44025$export$614f1ac7580ead5f('accepted');
        banner.classList.add('cookie-consent-hidden');
        setTimeout(()=>banner.remove(), 300);
        if (onAccept) onAccept();
    });
    // Handle decline
    document.getElementById('cookie-decline').addEventListener('click', ()=>{
        $9cf61c3cbfe44025$export$614f1ac7580ead5f('declined');
        banner.classList.add('cookie-consent-hidden');
        setTimeout(()=>banner.remove(), 300);
        if (onDecline) onDecline();
    });
    // Show banner with animation
    requestAnimationFrame(()=>{
        banner.classList.add('cookie-consent-visible');
    });
}
function $9cf61c3cbfe44025$export$e6ff0a9ac4e935ce() {
    return $9cf61c3cbfe44025$export$4aed0829426ce4f9() === 'accepted';
}


/**
 * Interactive Demo Calculator
 * Simple recipe cost calculator for landing page demo
 */ // Demo data
const $fce760a1480ca2a2$var$demoData = {
    ingredients: {
        bread: {
            name: 'Bread',
            purchasePrice: 1.5,
            purchaseAmount: 1,
            purchaseUnit: ' loaf',
            displayUnit: 'slices',
            conversionFactor: 0.06
        },
        cheese: {
            name: 'Cheddar Cheese',
            purchasePrice: 4.0,
            purchaseAmount: 500,
            purchaseUnit: 'g'
        },
        butter: {
            name: 'Butter',
            purchasePrice: 1.5,
            purchaseAmount: 250,
            purchaseUnit: 'g'
        }
    },
    recipe: {
        name: 'Cheese Sandwich',
        sellPrice: 3.5,
        ingredients: [
            {
                id: 'bread',
                amount: 2,
                unit: 'slices'
            },
            {
                id: 'cheese',
                amount: 30,
                unit: 'g'
            },
            {
                id: 'butter',
                amount: 10,
                unit: 'g'
            }
        ]
    }
};
/**
 * Convert units to base unit (grams or milliliters)
 */ function $fce760a1480ca2a2$var$convertToBaseUnit(amount, unit, ingredient) {
    // Handle display units (like "slices")
    if (unit === ingredient.displayUnit && ingredient.conversionFactor) return amount * ingredient.conversionFactor;
    // Standard conversions
    const conversions = {
        kg: 1000,
        g: 1,
        l: 1000,
        ml: 1
    };
    return amount * (conversions[unit.toLowerCase()] || 1);
}
/**
 * Calculate cost for a single ingredient
 */ function $fce760a1480ca2a2$var$calculateIngredientCost(ingredientId, amount, unit) {
    const ingredient = $fce760a1480ca2a2$var$demoData.ingredients[ingredientId];
    if (!ingredient) return 0;
    // Convert recipe amount to base unit
    const baseAmount = $fce760a1480ca2a2$var$convertToBaseUnit(amount, unit, ingredient);
    // Convert purchase amount to base unit
    const purchaseBaseAmount = $fce760a1480ca2a2$var$convertToBaseUnit(ingredient.purchaseAmount, ingredient.purchaseUnit, ingredient);
    // Cost per base unit
    const costPerUnit = ingredient.purchasePrice / purchaseBaseAmount;
    // Total cost for this ingredient
    return baseAmount * costPerUnit;
}
/**
 * Get default amount for an ingredient
 */ function $fce760a1480ca2a2$var$getDefaultAmount(ingredientId) {
    const defaults = {
        bread: {
            amount: 2,
            unit: 'slices'
        },
        cheese: {
            amount: 30,
            unit: 'g'
        },
        butter: {
            amount: 10,
            unit: 'g'
        }
    };
    return defaults[ingredientId] || {
        amount: 1,
        unit: 'g'
    };
}
/**
 * Get available ingredients (not in recipe)
 */ function $fce760a1480ca2a2$var$getAvailableIngredients() {
    const usedIds = new Set($fce760a1480ca2a2$var$demoData.recipe.ingredients.map((i)=>i.id));
    return Object.keys($fce760a1480ca2a2$var$demoData.ingredients).filter((id)=>!usedIds.has(id));
}
/**
 * Calculate total recipe cost and margin
 */ function $fce760a1480ca2a2$var$calculateRecipe() {
    let totalCost = 0;
    for (const recipeIngredient of $fce760a1480ca2a2$var$demoData.recipe.ingredients){
        const cost = $fce760a1480ca2a2$var$calculateIngredientCost(recipeIngredient.id, recipeIngredient.amount, recipeIngredient.unit);
        totalCost += cost;
    }
    const sellPrice = $fce760a1480ca2a2$var$demoData.recipe.sellPrice;
    const profit = sellPrice - totalCost;
    const margin = sellPrice > 0 ? profit / sellPrice * 100 : 0;
    return {
        totalCost: totalCost,
        sellPrice: sellPrice,
        profit: profit,
        margin: margin,
        breakdown: $fce760a1480ca2a2$var$demoData.recipe.ingredients.map((ri)=>({
                ...ri,
                name: $fce760a1480ca2a2$var$demoData.ingredients[ri.id]?.name || ri.id,
                cost: $fce760a1480ca2a2$var$calculateIngredientCost(ri.id, ri.amount, ri.unit)
            }))
    };
}
/**
 * Track demo event in PostHog (if available)
 */ function $fce760a1480ca2a2$var$trackDemoEvent(eventName, properties = {}) {
    if (window.posthog) window.posthog.capture(`demo_${eventName}`, {
        ...properties,
        source: 'landing_page_demo'
    });
}
/**
 * Format currency
 */ function $fce760a1480ca2a2$var$formatCurrency(amount) {
    return `\xa3${amount.toFixed(2)}`;
}
/**
 * Format percentage
 */ function $fce760a1480ca2a2$var$formatPercent(percent) {
    return `${percent.toFixed(1)}%`;
}
/**
 * Render ingredients panel
 */ function $fce760a1480ca2a2$var$renderIngredients() {
    const container = document.getElementById('demo-ingredients');
    if (!container) return;
    container.innerHTML = Object.entries($fce760a1480ca2a2$var$demoData.ingredients).map(([id, ingredient])=>`
    <div class="card card-padding">
      <label class="form-label">
        ${ingredient.name}
      </label>
      <div class="flex items-center gap-2">
        <span class="text-neutral-500 text-sm">\xa3</span>
        <input
          type="number"
          step="0.01"
          min="0"
          value="${ingredient.purchasePrice.toFixed(2)}"
          data-ingredient-id="${id}"
          class="demo-price-input input flex-1"
        />
        <span class="text-neutral-500 text-sm whitespace-nowrap">/ ${ingredient.purchaseAmount}${ingredient.purchaseUnit}</span>
      </div>
    </div>
  `).join('');
    // Add event listeners
    container.querySelectorAll('.demo-price-input').forEach((input)=>{
        input.addEventListener('input', (e)=>{
            const ingredientId = e.target.dataset.ingredientId;
            const newPrice = parseFloat(e.target.value) || 0;
            $fce760a1480ca2a2$var$demoData.ingredients[ingredientId].purchasePrice = newPrice;
            $fce760a1480ca2a2$var$trackDemoEvent('ingredient_price_changed', {
                ingredient: $fce760a1480ca2a2$var$demoData.ingredients[ingredientId].name,
                new_price: newPrice
            });
            $fce760a1480ca2a2$var$renderRecipe();
        });
    });
}
/**
 * Render recipe panel
 */ function $fce760a1480ca2a2$var$renderRecipe() {
    const container = document.getElementById('demo-recipe');
    if (!container) return;
    const result = $fce760a1480ca2a2$var$calculateRecipe();
    const marginColor = result.margin >= 65 ? 'text-success-500' : 'text-error-500';
    const marginBgColor = result.margin >= 65 ? 'bg-success-50' : 'bg-error-50';
    container.innerHTML = `
    <div class="space-y-4">
      <!-- Recipe header -->
      <div class="border-b border-neutral-100 pb-4">
        <h3 class="text-xl font-semibold text-neutral-900">${$fce760a1480ca2a2$var$demoData.recipe.name}</h3>
        <div class="mt-2 flex items-center gap-2">
          <label class="text-sm text-neutral-500">Sell Price:</label>
          <div class="flex items-center gap-1">
            <span class="text-neutral-500">\xa3</span>
            <input
              type="number"
              step="0.01"
              min="0"
              value="${$fce760a1480ca2a2$var$demoData.recipe.sellPrice.toFixed(2)}"
              id="demo-sell-price"
              class="input w-24 py-1.5"
            />
          </div>
        </div>
      </div>

      <!-- Ingredients list -->
      <div class="space-y-2">
        <h4 class="label">Ingredients:</h4>
        ${result.breakdown.map((item, index)=>`
          <div class="flex items-center justify-between bg-neutral-50 p-3 rounded-lg">
            <div class="flex items-center gap-3 flex-1">
              <input
                type="number"
                step="0.1"
                min="0"
                value="${item.amount}"
                data-index="${index}"
                class="demo-amount-input input w-20 py-1.5"
              />
              <span class="text-neutral-500 text-sm">${item.unit}</span>
              <span class="text-neutral-900">${item.name}</span>
            </div>
            <div class="flex items-center gap-3">
              <span class="text-neutral-700 font-medium">${$fce760a1480ca2a2$var$formatCurrency(item.cost)}</span>
              <button
                data-index="${index}"
                class="demo-remove-btn text-error-500 hover:text-error-600 p-1 transition-colors"
                title="Remove ingredient"
              >
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
        `).join('')}
      </div>

      <!-- Totals -->
      <div class="border-t border-neutral-100 pt-4 space-y-2">
        <div class="flex justify-between text-lg">
          <span class="font-semibold text-neutral-900">Total Cost:</span>
          <span class="font-bold text-neutral-900">${$fce760a1480ca2a2$var$formatCurrency(result.totalCost)}</span>
        </div>
        <div class="flex justify-between text-lg">
          <span class="font-semibold text-neutral-900">Profit:</span>
          <span class="font-bold ${result.profit >= 0 ? 'text-success-500' : 'text-error-500'}">${$fce760a1480ca2a2$var$formatCurrency(result.profit)}</span>
        </div>
        <div class="flex justify-between items-center ${marginBgColor} p-4 rounded-xl mt-4">
          <span class="font-semibold text-neutral-900 text-xl">Margin:</span>
          <span class="font-bold ${marginColor} text-2xl">${$fce760a1480ca2a2$var$formatPercent(result.margin)}</span>
        </div>
      </div>

      ${$fce760a1480ca2a2$var$getAvailableIngredients().length > 0 ? `
      <!-- Available Ingredients -->
      <div class="border-t border-neutral-100 pt-4 mt-4">
        <h4 class="label mb-2">Available Ingredients:</h4>
        <div class="space-y-2">
          ${$fce760a1480ca2a2$var$getAvailableIngredients().map((id)=>`
            <button
              data-ingredient-id="${id}"
              class="demo-add-btn w-full flex items-center justify-between bg-primary-50 hover:bg-primary-100 p-3 rounded-lg transition-colors"
            >
              <span class="text-neutral-900">${$fce760a1480ca2a2$var$demoData.ingredients[id].name}</span>
              <span class="text-primary-600 font-medium flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Add
              </span>
            </button>
          `).join('')}
        </div>
      </div>
      ` : ''}
    </div>
  `;
    // Add event listeners for sell price
    const sellPriceInput = document.getElementById('demo-sell-price');
    if (sellPriceInput) sellPriceInput.addEventListener('input', (e)=>{
        const newSellPrice = parseFloat(e.target.value) || 0;
        $fce760a1480ca2a2$var$demoData.recipe.sellPrice = newSellPrice;
        $fce760a1480ca2a2$var$trackDemoEvent('sell_price_changed', {
            new_sell_price: newSellPrice
        });
        $fce760a1480ca2a2$var$renderRecipe();
    });
    // Add event listeners for amounts
    container.querySelectorAll('.demo-amount-input').forEach((input)=>{
        input.addEventListener('input', (e)=>{
            const index = parseInt(e.target.dataset.index);
            const newAmount = parseFloat(e.target.value) || 0;
            const ingredient = $fce760a1480ca2a2$var$demoData.recipe.ingredients[index];
            $fce760a1480ca2a2$var$demoData.recipe.ingredients[index].amount = newAmount;
            $fce760a1480ca2a2$var$trackDemoEvent('ingredient_amount_changed', {
                ingredient: $fce760a1480ca2a2$var$demoData.ingredients[ingredient.id]?.name,
                new_amount: newAmount,
                unit: ingredient.unit
            });
            $fce760a1480ca2a2$var$renderRecipe();
        });
    });
    // Add event listeners for remove buttons
    container.querySelectorAll('.demo-remove-btn').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            const index = parseInt(e.currentTarget.dataset.index);
            const ingredient = $fce760a1480ca2a2$var$demoData.recipe.ingredients[index];
            $fce760a1480ca2a2$var$trackDemoEvent('ingredient_removed', {
                ingredient: $fce760a1480ca2a2$var$demoData.ingredients[ingredient.id]?.name,
                ingredients_remaining: $fce760a1480ca2a2$var$demoData.recipe.ingredients.length - 1
            });
            $fce760a1480ca2a2$var$demoData.recipe.ingredients.splice(index, 1);
            $fce760a1480ca2a2$var$renderRecipe();
        });
    });
    // Add event listeners for add buttons
    container.querySelectorAll('.demo-add-btn').forEach((button)=>{
        button.addEventListener('click', (e)=>{
            const ingredientId = e.currentTarget.dataset.ingredientId;
            const defaultAmount = $fce760a1480ca2a2$var$getDefaultAmount(ingredientId);
            $fce760a1480ca2a2$var$trackDemoEvent('ingredient_added', {
                ingredient: $fce760a1480ca2a2$var$demoData.ingredients[ingredientId]?.name,
                amount: defaultAmount.amount,
                unit: defaultAmount.unit,
                ingredients_total: $fce760a1480ca2a2$var$demoData.recipe.ingredients.length + 1
            });
            $fce760a1480ca2a2$var$demoData.recipe.ingredients.push({
                id: ingredientId,
                ...defaultAmount
            });
            $fce760a1480ca2a2$var$renderRecipe();
        });
    });
}
function $fce760a1480ca2a2$export$4de0a8fa6bf722f5() {
    $fce760a1480ca2a2$var$trackDemoEvent('demo_loaded');
    $fce760a1480ca2a2$var$renderIngredients();
    $fce760a1480ca2a2$var$renderRecipe();
}


/**
 * Waitlist Form Handler
 */ 
function $c983fd547ee26911$export$eef66295e67845a8() {
    const form = document.getElementById('signup-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
        const email = document.getElementById('email').value;
        // Track the signup in PostHog
        (0, $f91025ced40c6130$export$2c1f5f2ef3c49d7f)(email);
    // Form will submit to Formsubmit.co naturally
    });
}


/**
 * Navigation functionality
 */ /**
 * Smooth scroll for anchor links
 */ function $3dbe651fb76d0227$export$a3d398c490ac37e1() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                // Close mobile menu if open
                $3dbe651fb76d0227$var$closeMobileMenu();
            }
        });
    });
}
function $3dbe651fb76d0227$export$933baf54561e84b4() {
    const menuBtn = document.getElementById('mobile-menu-btn');
    const menu = document.getElementById('mobile-menu');
    if (!menuBtn || !menu) return;
    menuBtn.addEventListener('click', ()=>{
        const isOpen = !menu.classList.contains('hidden');
        if (isOpen) $3dbe651fb76d0227$var$closeMobileMenu();
        else $3dbe651fb76d0227$var$openMobileMenu();
    });
    // Close menu when clicking outside
    document.addEventListener('click', (e)=>{
        if (!menuBtn.contains(e.target) && !menu.contains(e.target)) $3dbe651fb76d0227$var$closeMobileMenu();
    });
    // Close menu on escape key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') $3dbe651fb76d0227$var$closeMobileMenu();
    });
}
function $3dbe651fb76d0227$var$openMobileMenu() {
    const menuBtn = document.getElementById('mobile-menu-btn');
    const menu = document.getElementById('mobile-menu');
    if (!menuBtn || !menu) return;
    menu.classList.remove('hidden');
    menuBtn.setAttribute('aria-expanded', 'true');
    // Update icon to X
    menuBtn.innerHTML = `
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
  `;
}
function $3dbe651fb76d0227$var$closeMobileMenu() {
    const menuBtn = document.getElementById('mobile-menu-btn');
    const menu = document.getElementById('mobile-menu');
    if (!menuBtn || !menu) return;
    menu.classList.add('hidden');
    menuBtn.setAttribute('aria-expanded', 'false');
    // Update icon to hamburger
    menuBtn.innerHTML = `
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  `;
}


// Initialize analytics only with consent
function $f5e5effd96d66274$var$initializeAnalytics() {
    (0, $f91025ced40c6130$export$74b04d0e740afc5d)();
    console.log((0, $9cf61c3cbfe44025$export$e6ff0a9ac4e935ce)());
    if (!(0, $9cf61c3cbfe44025$export$e6ff0a9ac4e935ce)()) // Show consent banner and init on acceptance
    (0, $9cf61c3cbfe44025$export$f4d3dcfc47dd8e3a)(()=>posthog?.opt_in_capturing(), ()=>posthog?.opt_out_capturing());
    else posthog?.opt_in_capturing();
}
// Initialize analytics
$f5e5effd96d66274$var$initializeAnalytics();
// Set up interactions
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $c983fd547ee26911$export$eef66295e67845a8)();
    (0, $3dbe651fb76d0227$export$a3d398c490ac37e1)();
    setupMobileMenu();
    (0, $fce760a1480ca2a2$export$4de0a8fa6bf722f5)();
});


//# sourceMappingURL=web.ad4802de.js.map
